import React from 'react';
import {
    FacebookLogo,
    TwitterLogo,
    InstagramLogo,
    YoutubeLogo
} from '@phosphor-icons/react';

const Footer = () => {
    return (
        <footer className="footer n0-bg position-relative">
            <div className="footer-top position-relative pt-xxl-30 pt-20 pb-xxl-25 pb-20">
                <div className="container">
                    <div className="toward-vision mb-xxl-15 mb-xl-12 mb-10">
                        <div className="row g-6 justify-content-between">
                            <div className="col-lg-5 col-md-6">
                                <div className="section-title">
                                    <h3 className="n900-clr mb-3">
                                        Simplifiez votre quotidien dès maintenant
                                    </h3>
                                    <p>
                                        Notre plateforme connecte des familles avec des aides ménagères qualifiées et vérifiées pour un service fiable et professionnel.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6">
                                <div className="footer-find">
                                    <img src="assets/images/logo/logo.png" alt="DHS" className="w-100" style={{width: '100%', height: '300px'}}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-between gy-lg-0 gy-7">
                        {/* Bloc 1 : À propos + réseaux sociaux */}
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer-widget">
                                <p className="max-408 n900-clr mb-xxl-6 mb-5 d-block">
                                    Driven Home Services  est la plateforme de confiance pour trouver des aides ménagères qualifiées et vérifiées, encadrées par des contrats sécurisés.
                                </p>
                                <ul className="-social d-flex align-items-center gap-xxl-3 gap-2">
                                    <li>
                                        <a href="#" className="icons d-center n30-bg radius-circle" aria-label="Facebook">
                                            <FacebookLogo size={35} weight="fill" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" className="icons d-center n30-bg radius-circle" aria-label="Twitter">
                                            <TwitterLogo size={35} weight="fill" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" className="icons d-center n30-bg radius-circle" aria-label="Instagram">
                                            <InstagramLogo size={35} weight="fill" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" className="icons d-center n30-bg radius-circle" aria-label="YouTube">
                                            <YoutubeLogo size={35} weight="fill" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Bloc 2 : Contact */}
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer-widget">
                                <h5 className="mb-sm-5 mb-3">
                                    Contactez-nous
                                </h5>
                                <ul className="footer-link d-grid gap-xxl-4 gap-3">
                                    <li className="d-flex align-items-start gap-3">
                                        <i className="ph ph-map-pin fs-five mt-1 p1-clr"></i>
                                        <a
                                            href="https://www.google.com/maps/search/?api=1&query=Immeuble+de+la+Pharmacie+de+la+Moisson+Poste+Centrale+Yaoundé+Cameroun"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="n200-clr"
                                        >
                                            Immeuble de la Pharmacie de la Moisson, Poste Centrale, Yaoundé, Cameroun
                                        </a>
                                    </li>
                                    <li className="d-flex align-items-start gap-3">
                                        <i className="ph ph-envelope fs-five mt-1 p1-clr"></i>
                                        <a href="mailto:drivenhomeservices237@gmail.com" className="n200-clr" target="_blank">
                                            drivenhomeservices237@gmail.com
                                        </a>
                                    </li>
                                    <li className="d-flex align-items-start gap-3">
                                        <i className="ph ph-phone fs-five mt-1 p1-clr"></i>
                                        <a href="tel:+237 6 74 69 85 18" className="n200-clr" target="_blank">
                                            +237 6 74 69 85 18
                                        </a>
                                    </li>
                                    <li className="d-flex align-items-start gap-3">
                                        <i className="ph ph-clock fs-five mt-1 p1-clr"></i>
                                        <span className="n200-clr">
                                            Lundi-Vendredi: 8h30-17h00<br/>
                                            Samedi: 9h-16h
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Bloc 3 : Mentions Légales */}
                        {/*<div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer-widget">
                                <h5 className="mb-sm-5 mb-3" style={{fontSize: '18px', fontWeight: '700', color: '#1e293b'}}>
                                    Mentions Légales
                                </h5>
                                <ul className="footer-link d-grid gap-xxl-3 gap-2" style={{listStyle: 'none', padding: 0}}>
                                    <li>
                                        <a href="/privacy-policy" style={{textDecoration: 'none', color: '#475569', transition: 'color 0.3s ease'}}
                                           onMouseEnter={(e) => e.currentTarget.style.color = '#116f19'}
                                           onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}>
                                            <i className="ph ph-shield-check me-2" style={{color: '#116f19'}}></i>
                                            Politique de confidentialité
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/terms" style={{textDecoration: 'none', color: '#475569', transition: 'color 0.3s ease'}}
                                           onMouseEnter={(e) => e.currentTarget.style.color = '#116f19'}
                                           onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}>
                                            <i className="ph ph-file-text me-2" style={{color: '#116f19'}}></i>
                                            Conditions d'utilisation
                                        </a>
                                    </li>

                                    <li>
                                        <a href="/legal-notice" style={{textDecoration: 'none', color: '#475569', transition: 'color 0.3s ease'}}
                                           onMouseEnter={(e) => e.currentTarget.style.color = '#116f19'}
                                           onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}>
                                            <i className="ph ph-gavel me-2" style={{color: '#116f19'}}></i>
                                            Mentions légales
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>*/}

                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <p className="n200-clr n40-bt text-center copyright py-xxl-6 py-xl-5 py-4">
                        Copyright &copy; <span className="currentYear">{new Date().getFullYear()}</span> Driven Home Services. Tous droits réservés.
                    </p>
                </div>
            </div>
            {/* Elements décoratifs */}
            <img src="assets/images/element/choose-twingle.png" alt="Décoration" className="biman-b"/>
            <img src="assets/images/element/choose-twingle2.png" alt="Décoration" className="biman-t"/>
        </footer>
    );
};

export default Footer;